module.exports = __webpack_public_path__ + "img/lead-03z.eb350e76.png";